import React from "react";

export default function Switch({
	checked = false,
	onChange,
	disabled = false,
	tooltip,
	className = "",
}) {
	const handleClick = (event) => {
		event.stopPropagation();

		if (disabled) return;

		onChange?.(!checked, event);
	};

	return (
		<span
			className={`tw-inline-flex tw-items-center tw-justify-center ${className}`}
			title={tooltip || undefined}
		>
			<button
				type="button"
				role="switch"
				aria-checked={checked}
				aria-disabled={disabled}
				disabled={disabled}
				onClick={handleClick}
				className={`tw-relative tw-inline-flex tw-h-[22px] tw-w-[40px] tw-items-center tw-rounded-full tw-border tw-transition-all ${
					disabled
						? "tw-cursor-not-allowed tw-border-[#D4D4D8] tw-bg-[#F5F5F5] tw-opacity-50"
						: checked
							? "tw-border-[var(--primary)] tw-bg-[var(--primary)]"
							: "tw-border-[#D4D4D8] tw-bg-[#E5E7EB] hover:tw-border-[#CFCFCF]"
				}`}
			>
				<span
					className={`tw-inline-block tw-h-[18px] tw-w-[18px] tw-rounded-full tw-bg-white tw-transition-transform ${
						disabled
							? "tw-translate-x-[2px] tw-border tw-border-[#D4D4D8] tw-shadow-none"
							: checked
								? "tw-translate-x-[20px] tw-shadow-sm"
								: "tw-translate-x-[2px] tw-shadow-sm"
					}`}
				/>
			</button>
		</span>
	);
}
